import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-dark-200/50 bg-dark">
      <div className="max-w-5xl mx-auto px-6 py-12">
        <p className="text-center text-gold/60 font-serif italic text-lg mb-8">
          "The light is one. The lamps are many."
        </p>

        <p className="text-center text-warm-100/40 text-xs mb-2">
          <a href="mailto:support@onelightmanylamps.ai" className="hover:text-gold transition-colors">
            support@onelightmanylamps.ai
          </a>
        </p>
        <p className="text-center text-warm-100/30 text-xs">
          Sato, with AI
        </p>
      </div>
    </footer>
  );
}
